import React, {memo, useEffect, useState} from 'react';
import {useQueryClient} from "react-query";
import {FormDialog }from "../../../../controls";
import FuelAnnexView from '../../../Fuel/components/FuelAnnexView';
import useGenerateFuelAnnex from '../../../../services/fuel/useGenerateFuelAnnex';

const ViewFuelAnnexDialog = (props) => {

  const classes = props.classes;
  const SystemData = props.systemData;
  const queryClient = useQueryClient();
  const eventBus = SystemData.eventBus;

  const [dialogState, setDialogState] = useState({
    showDialog: false,
    canEdit: false,
    fuelAnnexUuid: null,
    effectiveDate: null,
    title: 'Fuel Annex',
  });

  const annexData = useGenerateFuelAnnex({queryClient, extraKeys: [dialogState.fuelAnnexUuid, dialogState.effectiveDate], useCache: true});

  const DisplayForm = () => {
    return (
      <FormDialog
        title={dialogState.title}
        message=""
        open={dialogState.showDialog}
        record={{}}
        dialogOptions={{maxWidth: "1600", fullWidth: false}}
        classes={classes}
        buttons = {{
          cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
        }}
        onChange={(state) => {
          if (state.buttonPressed === "save") {
          } else {
            setDialogState({...dialogState, showDialog: false, record: null, handleSave: null});
            if (typeof props.onClose === 'function') {props.onClose()}
          }
        }}
      >
        <div style={{display: "inline-block", width: 1600}} checkChildren={true}>
          <FuelAnnexView annexData={annexData?.data} effectiveDate={dialogState.effectiveDate}/>
        </div>
      </FormDialog>
    )
  }

  useEffect(()=> {
    const open = async (params) => {
      //TODO: tripLegUuid should be primaryObjectUuid as it can be either tripLegUuid or tripUuid
      const {fuelAnnexUuid, effectiveDate} = params;
      setDialogState({...dialogState, showDialog:true, fuelAnnexUuid, effectiveDate});
    }
    eventBus.bind("ViewFuelAnnexDialog.open", open);
    return () => {
      eventBus.unbind("ViewFuelAnnexDialog.open", open);
    }
  }, [dialogState, eventBus, queryClient]);

  if (dialogState.showDialog) {
    if (annexData?.data && annexData.status === "success") {
      return (
        <DisplayForm />
      )
    } else if (annexData.status === "loading") {
      return (<>Pleased wait, Annex is being generated...</>);
    } else if (annexData.status === "error") {
      return (<>{annexData.error.message}</>);
    } else {
      return (<>No Annex data was returned.</>);     
    }
  }
  return (<></>);
}

export default memo(ViewFuelAnnexDialog);
